import PageHeader from "./PageHeader";

export default function ShippingPolicy() {
  return (
    <>
      <PageHeader seoKey={"shippingPolicy"} />
      <section className="container py-5">
        <div className="row g-4">
          <div className="col-lg-12">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-4">
                <h5 className="fw-bold mb-4">Shipping Policy</h5>

                <ol type="i" className="mb-4">
                  <li>
                    Free Shipping on all orders over the value of{" "}
                    <strong>Rs. 6,000/-</strong>.
                  </li>
                  <li>
                    We charge <strong>Rs. 250</strong> for deliveries all over
                    Pakistan on all orders under the value of Rs. 6,000/-.
                  </li>
                  <li>
                    Orders received on Sundays and on Pakistan’s National
                    Holidays will be processed and shipped on the next working
                    day.
                  </li>
                  <li>
                    Delivery time is between <strong>3 to 5 working days</strong>{" "}
                    (No delivery on Sundays).
                  </li>
                  <li>
                    On orders above the value of <strong>Rs. 8,000</strong> we
                    will need an advance payment. Customers will be contacted
                    for payment information on order confirmation and the
                    account details will be communicated then. These orders will
                    not be shipped via a courier.
                  </li>
                </ol>

                <p className="text-muted mb-0">
                  For further queries regarding shipping, please contact us at{" "}
                  <strong>auraskinpremium@gmail.com</strong> or WhatsApp at{" "}
                  <strong>0311-7266767</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
